import React from "react";
import { TableRow, TableCell, Paper } from "@material-ui/core";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { TableAction, TableWrapper } from "App/Component/ui";

import { useDatatables } from "App/hooks";

export default function TableUserAccess({ rows, handleClickUpdate }) {
  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "user_id",
    orderByRow: ["user_id"],
  });

  return (
    <>
      <div
        style={{
          marginTop: "1rem",
        }}>
        <Paper>
          <TableWrapper
            title=''
            type='CUSTOM'
            setQ={setQ}
            withAddButton={false}
            withExportButton={false}
            order={order}
            orderBy={orderBy}
            handleRequestSort={handleRequestSort}
            length={length}
            rows={rows}
            headCells={headCells}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}>
            {stableSort(data, getComparator(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <TableRow
                    hover
                    tabIndex={-1}
                    key={index}
                    style={{
                      backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                    }}>
                    <TableCell
                      component='th'
                      scope='row'
                      padding='none'
                      width={"5%"}
                      align='center'>
                      {index + 1}
                    </TableCell>
                    <TableCell
                      component='th'
                      scope='row'
                      padding='none'
                      width='5%'>
                      <TableAction
                        clickUpdate={() => handleClickUpdate(row)}
                        isDelete={false}
                      />
                    </TableCell>

                    <TableCell align='left' colSpan={headCells.length - 1}>
                      {row.username}
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableWrapper>
        </Paper>
      </div>
    </>
  );
}

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "username",
    disablePadding: false,
    label: "USERNAME",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "table_name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
];
